import Request from './Request';

export interface IOverview {
	id: number;
	name: string;
	code: string;
	featured: boolean;
	level: number;
	year: number;
	lastYear: IOverview;
	children: IOverview[];
	financialSalesActual: number;
	financialSalesSRE: number;
	financialSalesFRE: number;
	financialSalesLE: number;
	financialSalesOP: number;
	financialSalesBusinessPlan: number;
	financialSalesForecastWeek1: number;
	financialSalesForecastWeek2: number;
	financialSalesForecastWeek3: number;
	financialSalesForecastWeek4: number;
	financialSalesMonthTodayWeek1: number;
	financialSalesMonthTodayWeek2: number;
	financialSalesMonthTodayWeek3: number;
	financialSalesMonthTodayWeek4: number;
	tradeSalesActual: number;
	tradeSalesSRE: number;
	tradeSalesFRE: number;
	tradeSalesLE: number;
	tradeSalesOP: number;
	tradeSalesBusinessPlan: number;
	tradeSalesForecastWeek1: number;
	tradeSalesForecastWeek2: number;
	tradeSalesForecastWeek3: number;
	tradeSalesForecastWeek4: number;
	tradeSalesMonthTodayWeek1: number;
	tradeSalesMonthTodayWeek2: number;
	tradeSalesMonthTodayWeek3: number;
	tradeSalesMonthTodayWeek4: number;
	approver: string;
	isApproved: boolean;
}

export interface IChannelTS {
	name: string;
	tradeSalesSRE: number;
	tradeSalesFRE: number;
	tradeSalesLE: number;
	tradeSalesOP: number;
	tradeSalesBusinessPlan: number;
	tradeSalesActual: number;
	isSales: boolean;
}
export interface IChannelFC {
	name: string;
	tradeSalesForecastWeek1: number;
	tradeSalesForecastWeek2: number;
	tradeSalesForecastWeek3: number;
	tradeSalesForecastWeek4: number;
	tradeSalesMonthTodayWeek1: number;
	tradeSalesMonthTodayWeek2: number;
	tradeSalesMonthTodayWeek3: number;
	tradeSalesMonthTodayWeek4: number;
	tradeSalesFCT: number;
	isSales: boolean;
}

export interface IOverviewChannel {
	id: number;
	name: string;
	code: string;
	featured: boolean;
	level: number;
	year: number;
	latitude: number;
	longitude: number;
	order: number;
	lastYear: IOverviewChannel;
	children: IOverviewChannel[];
	financialSalesActual: number;
	financialSalesForecastWeek1: number;
	financialSalesForecastWeek2: number;
	financialSalesForecastWeek3: number;
	financialSalesForecastWeek4: number;
	financialSalesMonthTodayWeek1: number;
	financialSalesMonthTodayWeek2: number;
	financialSalesMonthTodayWeek3: number;
	financialSalesMonthTodayWeek4: number;
	tradeSalesChannels: IChannelTS[];
	forecastChannels: IChannelFC[];
}

export function getOverviewTS(obj: IOverview, tstype1: string): number {

	if (obj == null)
		return 0;

	const valueBase: number =
		tstype1 === "BP" ? obj.tradeSalesBusinessPlan :
			tstype1 === "SRE" ? obj.tradeSalesSRE :
				tstype1 === "LE" ? obj.tradeSalesLE :
					tstype1 === "OP" ? obj.tradeSalesOP :
						tstype1 === "FRE" ? obj.tradeSalesFRE :
							0;
	return valueBase;
}

export function getOverviewFS(obj: IOverview, tstype1: string): number {

	if (obj == null)
		return 0;

	const valueBaseFS: number =
		tstype1 === "BP" ? obj.financialSalesBusinessPlan :
			tstype1 === "SRE" ? obj.financialSalesSRE :
				tstype1 === "LE" ? obj.financialSalesLE :
					tstype1 === "OP" ? obj.financialSalesOP :
						tstype1 === "FRE" ? obj.financialSalesFRE :
							0;

	return valueBaseFS;
}

export function getChannelTS(obj: IChannelTS, tstype1: string): number {

	if (obj == null)
		return 0;

	const valueBase: number =
		tstype1 === "BP" ? obj.tradeSalesBusinessPlan :
			tstype1 === "SRE" ? obj.tradeSalesSRE :
				tstype1 === "LE" ? obj.tradeSalesLE :
					tstype1 === "OP" ? obj.tradeSalesOP :
						tstype1 === "FRE" ? obj.tradeSalesFRE :
							0;
	return valueBase;
}

class Dashboard {
	static GetOverview = (code: string, year: number, month: number): IOverview => { return Request.DoGet('dashboard/overview/' + code + "/" + year + "/" + month) as unknown as IOverview; };
	static GetYTDOverview = (code: string, year: number, month: number): IOverview => { return Request.DoGet('dashboard/overview/ytd/' + code + "/" + year + "/" + month) as unknown as IOverview; };
	static GetChannel = (code: string, year: number, month: number): IOverviewChannel => { return Request.DoGet('dashboard/channel/' + code + "/" + year + "/" + month) as unknown as IOverviewChannel; };
	static GetYTDChannel = (code: string, year: number, month: number): IOverviewChannel => { return Request.DoGet('dashboard/channel/ytd/' + code + "/" + year + "/" + month) as unknown as IOverviewChannel; };
}

export default Dashboard;